import "../styles/infocard.css";

const InfoCard = (props) => {
  return (
    <>
      <div className="infoCardContainer">{props.copy}</div>
    </>
  );
};

export default InfoCard;
